export default "__VITE_ASSET__OFl32cKn__"